








































































































































































import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { ServerReportType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import MainMixin from '../../mixins/MainMixin'
@Component({
  components: {
    CDatePicker,
  },
})
export default class ServerReport extends Mixins(MainMixin) {
  @Prop() title!:string

  @Prop() shifts!:any

  @Prop() users!:any

  get isValid() {
    if (!this.$refs || !this.$refs.obs) return false
    const x:any = this.$refs.obs
    if (!x.flags || !x.flags.valid) {
      return false
    }
    // const x:any = this.$refs.obs.flags.valid
    console.log('x flags: ', x.flags)
    return x.flags.valid
  }

  data:ServerReportType = {
    user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
    shift: '',
    date: '',
    sales: null,
    comps: [],
    voids: [],
    foodTimingRating: 0,
    foodQualityRating: 0,
    teamworkRating: 0,
    overallRating: 0,
    incidents: '',
    comments: '',
  }

  clearForm() {
    this.numberComps = 0
    this.numberVoids = 0
    this.data = {
      user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
      shift: '',
      date: '',
      sales: 0,
      comps: [],
      voids: [],
      foodTimingRating: 0,
      foodQualityRating: 0,
      teamworkRating: 0,
      overallRating: 0,
      incidents: '',
      comments: '',
    }
    const xx:any = this.$refs.obs
    xx.reset()
  }

  numberComps = 0

  numberVoids = 0

  presubmit() {
    if (this.data.sales) this.data.sales = Number(this.data.sales)
    return true
  }

  @Watch('numberComps')
  changedComps(newNumberComps:number) {
    console.log('going now', newNumberComps)
    if (newNumberComps > this.data.comps.length) this.data.comps.push({ checkNumber: '', amount: 0, explaination: '' })
    else this.data.comps.pop()
  }

  @Watch('numberVoids')
  changedVoids(newNumberVoids:number) {
    console.log('going now', newNumberVoids)
    if (newNumberVoids > this.data.voids.length) this.data.voids.push({ checkNumber: '', amount: 0, explaination: '' })
    else this.data.voids.pop()
  }

  created() {
    if (!this.$store.getters.multiUser) {
      this.data.user = this.$store.getters.uid
    }
  }
}

